import { Common } from '@stockbit/ui';
import { memo } from 'react';
import Image from 'global/Image';

const { Card, Flex, Text } = Common;

export const DefaultCard = memo(() => {
  return (
    <Card>
      <Flex width="100%" justify="center" align="center" height="300px">
        <Image src="/icon/settings.svg" alt="profile-setting" />
      </Flex>
    </Card>
  );
});

export const InProgressCard = memo(() => {
  return (
    <Card data-cy="settings-in-progress-card">
      <Flex
        width="100%"
        justify="center"
        align="center"
        height="320px"
        direction="column"
      >
        <Flex style={{ minHeight: '136px' }}>
          <Image src="/icon/settings-in-progress.svg" alt="profile-setting" />
        </Flex>

        <Flex width="100%" justify="center" align="center" direction="column">
          <Text size="16px" weight="bold" style={{ marginTop: 20 }}>
            Pembaruan Data Dalam Proses
          </Text>

          <Text size="14px" style={{ marginTop: 8 }}>
            Kamu baru bisa mengubah data lain setelah proses pembaruan selesai.
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
});
